module.exports = __webpack_public_path__ + "static/transforming-the-future-633c9d7e75cc84bf1f26fef4d3dc2978.jpg";